import Theme from '@jetbrains/ring-ui/components/global/theme'
import Radio from '@jetbrains/ring-ui/components/radio/radio'

import {setGlobalTheme} from '../../../../actions/theme'
import {useUserTheme} from '../../../../hooks/theme/useUserTheme'
import {useSetUserProperty} from '../../../../hooks/useSetUserProperty'
import {UserProperties} from '../../../../utils/userProperties'

import styles from './ThemeSwitcher.css'

function ThemeSwitcher() {
  const theme = useUserTheme()
  const setUserProperty = useSetUserProperty()
  return (
    <label className={styles.container}>
      <span className={styles.label}>{'Theme'}</span>
      <Radio
        value={theme}
        onChange={value => {
          setUserProperty(UserProperties.THEME, value)
          setGlobalTheme(value as Theme)
        }}
      >
        <Radio.Item value={Theme.LIGHT}>{'Light'}</Radio.Item>
        <Radio.Item value={Theme.DARK}>{'Dark'}</Radio.Item>
        <Radio.Item value={Theme.AUTO}>{'Sync with OS'}</Radio.Item>
      </Radio>
    </label>
  )
}

export default ThemeSwitcher
